import { Locale } from 'shared/i18n/interface'
import config from 'config'

export const buildFavoritesUrl = (favoritesPath: string | undefined, locale: Locale, params: string): string => {
  if (!favoritesPath) return ''
  const vistaprintRoot = config.client.vistaprintRoot[locale]
  const favoritesUrl = `${vistaprintRoot}${favoritesPath}?tab=templates&${params}`

  return favoritesUrl
}
